export const SUB_TITLE = 'Choose 3';
export const TITLE = 'Your Preferred Genres';
